import LoggerFactory from '@/services/utils/LoggerFactory';
const logger = LoggerFactory.getLogger('utils/FontLoader.js');

import FontNamesEnum from '@/enums/FontNamesEnum';

const FONTS_SETTINGS_MAP = {
  [FontNamesEnum.AMIRI]: {
    src: `url(${require('@/assets/fonts/Amiri-20180807/Amiri.woff')})`,
    fontFamily: 'Amiri',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.ARNO_PRO]: {
    src: `url(${require('@/assets/fonts/ArnoPro-20160108/ArnoPro.ttf')})`,
    fontFamily: 'ArnoPro',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.CABIN]: {
    src: `url(${require('@/assets/fonts/Cabin-20160101/Cabin-Regular_dot.otf')})`,
    fontFamily: 'Cabin',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.CABIN_BOLD]: {
    src: `url(${require('@/assets/fonts/Cabin-20160101/Cabin-Bold_dot.otf')})`,
    fontFamily: 'CabinBold',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.DYSLEXIC]: {
    src: `url(${require('@/assets/fonts/OpenDyslexic-20160101/OpenDyslexic-Regular.otf')})`,
    fontFamily: 'Dyslexic',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.GARAMOND_1689]: {
    src: `url(${require('@/assets/fonts/Garamond1689-20160112/Garamond1689.otf')})`,
    fontFamily: 'Garamond1689',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.GENTIUM]: {
    src: `url(${require('@/assets/fonts/Gentium-20160101/GentiumPlus-R.woff2')})`,
    fontFamily: 'Gentium',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.GOUDY_HANDTOOLED]: {
    src: `url(${require('@/assets/fonts/GoudyHandtooled-20160112/GoudyHandtooled.otf')})`,
    fontFamily: 'GoudyHandtooled',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.MARCO_POLO]: {
    src: `url(${require('@/assets/fonts/MarcoPolo-20160125/MarcoPolo.woff')})`,
    fontFamily: 'MarcoPolo',
    fontStyle: 'normal',
    fontWeight: '300'
  },
  // [FontNamesEnum.NUNITO_SANS]: {
  //   src:
  //     "url(\"https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap\") local('Helvetica Neue'), local('Roboto'), local('SegoeUI'), local(Helvetica),\n" +
  //     '//     local(Arial)',
  //   fontFamily: 'Nunito Sans',
  //   fontStyle: 'normal',
  //   fontWeight: '300'
  // },
  [FontNamesEnum.ROMANTIK]: {
    src: `url(${require('@/assets/fonts/Initials-20160512/Romantik.otf')})`,
    fontFamily: 'Romantik',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.SANCHEZ]: {
    src: `url(${require('@/assets/fonts/Sanchez-20160101/Sanchez-Regular_dot.otf')})`,
    fontFamily: 'Sanchez',
    fontStyle: 'normal',
    fontWeight: 'normal'
  },
  [FontNamesEnum.TYPEWRITTER]: {
    src: `url(${require('@/assets/fonts/SpecialElite-Typewriter-20160315/SpecialElite-webfont.woff')})`,
    fontFamily: 'Typewriter',
    fontStyle: 'normal',
    fontWeight: 'normal'
  }
};

const getFontsStyles = (fontNames = [], hid) => {
  try {
    const cssText = fontNames.reduce((result, name) => {
      result += _composeFontFace(name);
      return result;
    }, '');

    return {
      hid,
      cssText: cssText,
      type: 'text/css'
    };
  } catch (error) {
    logger.error(`Get fonts styles failed with ${error}`);
    return {};
  }
};

const downloadFonts = async (fontNames = []) => {
  const fontsData = fontNames.map(fontName => {
    const {
      fontFamily,
      src,
      fontStyle: style,
      fontWeight: weight
    } = FONTS_SETTINGS_MAP[fontName];

    const font = new FontFace(fontFamily, src, {
      style,
      weight
    });
    return font.load();
  });

  return Promise.all(fontsData);
};

const loadFonts = fontNames => {
  const fontsStyles = getFontsStyles(fontNames);
  _injectFontStyles(fontsStyles);
};

function _composeFontFace(fontName) {
  const fontSettings = FONTS_SETTINGS_MAP[fontName];

  if (!fontSettings) {
    return '';
  }

  return `@font-face {
    font-family: ${fontSettings.fontFamily};
    src: ${fontSettings.src};
    font-weight: ${fontSettings.fontWeight};
    font-style: ${fontSettings.fontStyle};
  }`;
}

function _injectFontStyles(fontsStyles) {
  const style = document.createElement('style');
  style.setAttribute('type', fontsStyles.type);
  style.innerHTML = fontsStyles.cssText;
  document.body.appendChild(style);
}

function getBookFontNames() {
  return [
    FontNamesEnum.GARAMOND_1689,
    FontNamesEnum.MARCO_POLO,
    FontNamesEnum.GOUDY_HANDTOOLED,
    FontNamesEnum.DYSLEXIC,
    FontNamesEnum.CABIN,
    FontNamesEnum.GENTIUM,
    FontNamesEnum.SANCHEZ,
    FontNamesEnum.ROMANTIK
  ];
}

export default {
  loadFonts,
  downloadFonts,
  getBookFontNames,
  getFontsStyles
};
